<template>
    <div class="powerStationNew-left-box">
        <title1 title="考核指标" subTitle="Assessment Index" class="mt-80"/>
        <div class="flex justify-between mt-100">
            <div
                v-for="(item, i) in target1"
                :key="'target1' + i"
                class="flex flex1 flex-direction align-center target1 ">
                <img class="img" :src="require('@/assets/images/exposition/chd-bg-1.png')" alt="">
                <!-- <span class="num">{{ item.number }}</span> -->
                <div class="num mt-20" v-if="item.overTenThousand">{{ item.number | overTenThousand }}</div>
                <div class="num mt-20" v-else>{{ item.number }}</div>
                <div class="label mt-20">{{ item.label }}</div>
            </div>
        </div>

        <div class="flex flex-wrap mt-120 justify-between">
            <div
                v-for="(item, i) in target2"
                :key="'target1' + i"
                class="flex align-center justify-center target2 mt-70 ">
                <!-- <div class="flex flex-direction align-center mr-15"> -->
                    <img class="img" :src="require('@/assets/images/exposition/chd-bg-2.png')" alt="">
                <!-- </div> -->
                <div>
                    <div class="label">{{ item.label }}</div>
                    <div class="num num3  flex justify-center mt-15">{{ item.number || '0' }}</div>
                    <!-- <div class="flex justify-between">
                        <span>{{ item.tips }}</span>
                        <span>{{ item.ratio }}</span>
                    </div> -->
                </div>
            </div>
        </div>

        <title1 class="mt-150" type="2" title="本月运营业务收入" style="margin-bottom: 20px;"/>
        <div class="box-1 mt-70">
            <myEchart
                v-if="operatingRevenueShow"
                id="operatingRevenue"
                :options="operatingRevenueOptions" />
        </div>

        <title1 class="mt-165" type="2" title="订单趋势" />
        <div class="box-1 mt-70">
            <myEchart
                v-if="orderTrendsShow"
                id="orderTrends"
                :options="orderTrendsOptions" />
            </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { dataInterface } from "@/api/dataInterfaceApi"
import myEchart from '@/views/exposition/components/charts/echarts'
import * as echarts from 'echarts5'
export default {
    components: {
        title1,
        myEchart
    },
    data() {
        let { stationId } = this.$route.query
        return {
            stationId: stationId,
            target1: [
                {
                    number: '',
                    // overTenThousand: true,
                    label: '本月运营收入(元)'
                },
                {
                    number: '',
                    // overTenThousand: true,
                    label: '本月运营成本(元)'
                },
                {
                    number: '',
                    // overTenThousand: true,
                    label: '本月充电电量(度)'
                },
            ],
            target2: [
                {
                    number: '',
                    label: '本月有效换电率(%)',
                    tips: '较上月',
                    ratio: '1.00%'
                },
                {
                    number: '',
                    label: '本月客户满意度(%)',
                    tips: '较上月',
                    ratio: '1.00%'
                },
                {
                    number: '',
                    label: '本月累计碳减排(cc)',
                    tips: '较上月',
                    ratio: '1.00%'
                },
                {
                    number: '',
                    label: '安全运营天数(天)',
                    tips: '较上月',
                    ratio: '1.00%'
                },
            ],
            operatingRevenueShow: false,
            operatingRevenueOptions: {},

            orderTrendsShow: false,
            orderTrendsOptions: {}
        }
    },
    methods: {
        getData(data) {
            // 考核指标收入
            this.kaohezhibiaoshouru(data)
            // 考核指表碳减排
            this.kaohezhibiaotanjianpai(data)
            // 运营业务收入
            this.yunyingyewushouru(data)
            // 订单趋势图
            this.dingdanqushitu(data)
        },

        // 考核指标收入
        kaohezhibiaoshouru(data = {}) {
            let params = {
                'enCode': 'TiDB-zhandian-kaohezhibiaoshouru',
                '@station_id': this.stationId
            }
            dataInterface.dataFaceApi(params).then( res => {
                if(!res || !res.length) return
                let data = res[0] || {}
                this.target1[0].number = data.oper_income
                this.target1[1].number = data.charge_cost
                this.target1[2].number = data.totalelect
            })
        },

        // 考核指表碳减排
        kaohezhibiaotanjianpai(data = {}) {
            let params = {
                'enCode': 'TiDB-zhandian-kaohezhibiaotanjianpai',
                '@station_id': this.stationId
            }
            dataInterface.dataFaceApi(params).then( res => {
                if(!res || !res.length) return
                let data = res[0] || {}
                this.target2[0].number = data.EffectiveConversionRate
                this.target2[1].number = data.CustomerSatisfaction
                this.target2[2].number = data.carbon_emissions_cc
                this.target2[3].number = data.SafeDays
            })
        },

        // 运营业务收入
        yunyingyewushouru(data = {}) {
			let params = {
				'enCode': 'TiDB-zhandian-yunyingyewushouru',
                '@station_id': this.stationId
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// let data = res && res[0] || {}
                let xData = []
                let yData1 = []
                let yData2 = []
                res.map(item => {
                    xData.push(item.cur_date)
                    yData1.push((parseFloat(item.last_oper_income || 0) / 10000).toFixed(2))
                    yData2.push((parseFloat(item.cur_oper_income || 0) / 10000).toFixed(2))
                })
                this.operatingRevenueShow = false
                this.operatingRevenueOptions = {
                    title: {
                        text: '万元'
                    },
                    color: ['#f2bd4c','#8bcfd0'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '上月营收',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(235, 190, 77, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(235, 190, 76, 0)'
                                    }
                                ])
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(235, 190, 77, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(235, 190, 76, 0)'
                                    }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 万元';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData1
                        },
                        {
                            name: '本月营收',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(139, 207, 208, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(134, 201, 203, 0)'
                                    }
                                ])
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(139, 207, 208, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(134, 201, 203, 0)'
                                    }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 万元';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData2
                        },
                    ]
                }
                this.operatingRevenueShow = true
			})
			.catch((err) => {
				console.log(err)
			})
		},

        // 订单趋势图
        dingdanqushitu(data = {}) {
			let params = {
				'enCode': 'TiDB-zhandian-dingdanqushitu',
                '@station_id': this.stationId
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// let data = res && res[0] || {}
                let xData = []
                let yData1 = []
                res.map(item => {
                    xData.push(item.cur_date)
                    yData1.push(item.power_exchange_order_num)
                })
                this.orderTrendsShow = false
                this.orderTrendsOptions = {
                    title: {
                        text: '单'
                    },
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '订单数量',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(139, 207, 208, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(134, 201, 203, 0)'
                                    }
                                ])
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                    {
                                        offset: 0,
                                        color: 'rgba(139, 207, 208, 1)'
                                    },
                                    {
                                        offset: 1,
                                        color: 'rgba(134, 201, 203, 0)'
                                    }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 单';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData1
                        },
                    ]
                }
                this.orderTrendsShow = true
			})
			.catch((err) => {
				console.log(err)
			})
		},
    }
}
</script>

<style lang="scss" scoped>
@import '../scss/powerStationNew.scss';
</style>